import React, { useState } from "react";
import { Checkbox, Divider, Input, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Avatar from "../../../../components/avatar";
import styles from "./formCheckBox.module.less";
const CheckboxGroup = Checkbox.Group;
const FormCheckBox = ({
  value = [],
  onChange,
  dataList,
  onSearch,
  initData,
}) => {
  const handleChange = (record, e) => {
    const { checked } = e.target;
    if (checked) {
      // 最多条数
      if (value.length >= initData.lotteryNumber) {
        message.warning(`最多可添加${initData.lotteryNumber}人`);
        return;
      }
      onChange([
        ...value,
        {
          joinLogId: record.joinLogId,
          id: record.id,
          avatarUrl: record.avatarUrl,
          nickName: record.nickName,
          role: record.role,
        },
      ]);
    } else {
      onChange(value.filter((ele) => ele.id !== record.id));
    }
  };
  // 删除
  const delItem = (record) => {
    onChange(value.filter((ele) => ele.id !== record.id));
  };
  return (
    <div className={styles.formCheckBox}>
      <Input.Search
        style={{ width: 260 }}
        placeholder="搜索昵称"
        onSearch={onSearch}
      />
      <div className={styles.listTitle}>待选人员</div>
      <Divider type="horizontal" />
      {dataList.map((ele) => (
        <Checkbox
          value={ele.id}
          key={ele.id}
          onChange={handleChange.bind(this, ele)}
          checked={value.some((cur) => cur.id === ele.id)}
        >
          <Avatar
            key={ele.id}
            avatarUrl={ele.avatarUrl}
            nickName={ele.nickName}
            role={ele.role}
            itemWidth={60}
            imgHeight={30}
          />
        </Checkbox>
      ))}
      <div className={styles.listTitle}>已选中的人员</div>
      <Divider type="horizontal" />
      <div className={styles.itemList}>
        {value &&
          value.map((item) => {
            return (
              <div
                className={styles.itemWarp}
                onClick={delItem.bind(this, item)}
              >
                <div className={styles.itemClose}>
                  <CloseOutlined className={styles.itemCloseIcon} />
                </div>
                <Avatar
                  key={item.id}
                  avatarUrl={item.avatarUrl}
                  nickName={item.nickName}
                  role={item.role}
                  itemWidth={60}
                  imgHeight={30}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
export default FormCheckBox;
